import { PureComponent } from 'react';

import trackEvent from '../helpers/trackEvent';
import styles from '../styles/ReferralLinkStyle.less';
import LinkIcon from './icons/LinkIcon';

export interface IReferralLinkProps {
  formattedUrl?: string;
  url: string;
}

export interface IReferralLinkState {
  copyMessage?: string;
}

class ReferralLink extends PureComponent<IReferralLinkProps, IReferralLinkState> {
  public state: IReferralLinkState = {};

  public onCopyClick = () => {
    const { url } = this.props;
    const tempInput = document.createElement('input');
    tempInput.setAttribute('style', 'position: absolute; left: -10000px; top: -10000px');
    tempInput.setAttribute('value', url);
    document.body.appendChild(tempInput);
    tempInput.select();
    const success = document.execCommand('copy');
    document.body.removeChild(tempInput);
    trackEvent('click', 'copy', {
      success,
      referralUrl: this.props.url,
    });
    if (!success) {
      this.setState({ copyMessage: 'Error copying' });
      return;
    }
    this.setState({ copyMessage: 'Copied!' });
  };

  public render() {
    const { formattedUrl, url } = this.props;
    const { copyMessage } = this.state;

    return (
      <div className={styles.container}>
        <span className={styles['link-container']}>
          <span className={styles.icon}>
            <LinkIcon />
          </span>
          <a
            className={styles.link}
            href={url}
            onClick={trackEvent.bind(null, 'click', 'referral-link', {
              referralUrl: url,
            })}
            target="_blank"
            rel="noopener noreferrer"
          >
            {formattedUrl || url}
          </a>
        </span>
        {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events */}
        <span className={styles.button} onClick={this.onCopyClick} role="button" tabIndex={0}>
          {copyMessage || 'Copy'}
        </span>
      </div>
    );
  }
}

export default ReferralLink;
